import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';

@Component({
  selector: 'app-firma',
  templateUrl: './firma.component.html',
  styleUrls: ['./firma.component.css']
})
export class FirmaComponent {
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @Output() Complete = new EventEmitter();
  signaturePadOptions: Object = {
    'minWidth': 5,
    'canvasWidth': 700,
    'canvasHeight': 300
  };
  ngAfterViewInit() {
    this.signaturePad.clear();
  }
  drawComplete() {
    //console.log(this.signaturePad.toDataURL("image/png"));
    this.Complete.emit(this.signaturePad)
  }
  drawStart() {
    console.log('begin drawing');
  }

}
